import { useQuery } from '@tanstack/react-query';
import { getCurrentUserId } from '../lib/supabase';
import {
  DEFAULT_REPORTING_USER_CONTEXT,
  loadReportingUserContext,
} from '../services/reporting/reporting-user-context';

export function useReportingUserContext() {
  return useQuery({
    queryKey: ['reporting', 'userContext'],
    queryFn: async () => {
      const uid = await getCurrentUserId();
      if (!uid) return DEFAULT_REPORTING_USER_CONTEXT;
      return loadReportingUserContext(uid);
    },
    staleTime: 60_000,
  });
}
